import React, {useContext, useEffect, useState} from "react";
import {KatButton, KatButtonGroup} from "@amzn/katal-react";
import {GlobalContext} from "src/context/GlobalProvider";
import {REGION_LABEL} from "src/common/constants/constants";
import {Region} from "src/context/models/Session";
import {setRegionAction} from "src/context/actions/SessionActions";
import {useTranslation} from "react-i18next";

export const RegionSelector = () => {
    const {t} = useTranslation();
    const {sessionDispatch, sessionState} = useContext(GlobalContext);
    const handleOnChange = (event: KatButtonGroup.ChangeEvent) => {
        setRegionAction(sessionDispatch, event.detail.value as Region)
    }

    return (<KatButtonGroup id="region-selector" expanded value={sessionState.data.region}
                            onChange={(e) => handleOnChange(e)}>
        <KatButton label={t(REGION_LABEL.NA)} value={Region.NA}/>
        <KatButton label={t(REGION_LABEL.EU)} value={Region.EU}/>
        <KatButton label={t(REGION_LABEL.FE)} value={Region.FE}/>
    </KatButtonGroup>);
}